module.exports = __webpack_public_path__ + "img/web.99d01c85.png";